export const ErrorNRLogs = {
  webFetchRequest: 'web_fetch_request',
  webFetchError: 'web_fetch_error',
  webGetFetchError: 'web_get_fetch_error',
  webFetchPostError: 'web_fetch_post_error',
  webFetchPostWithFormDataError: 'web_fetch_post_with_form_data_error',
  webRefreshTokenNotSet: 'web_refresh_token_not_set',

  // Refresh Token Logs
  webRefreshTokenError: 'web_refresh_token_error',
  webRefreshTokenBadRequestError: 'web_refresh_token_bad_request',
  webRefreshTokenSuccess: 'web_refresh_token_success',

  // Individual API logs
  webFnoPositionAPIError: 'web_fno_position_api_error',
}
